
import {
    defineComponent,
    onMounted
} from 'vue'
import echarts from 'echarts';

export default defineComponent({
    name: 'CigoEchartsBasicLine',
    setup(props, ctx) {
        let option: any = {
            xAxis: {
                type: 'category',
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: [820, 932, 901, 934, 1290, 1330, 1320],
                type: 'line'
            }]
        };

        onMounted(() => {
            drawChart();
        });

        const drawChart = () => {
            let elementById: any = document.getElementById("basicLine");
            let lineChart = echarts.init(elementById);
            lineChart.setOption(option);
        };

        return {};
    }
})
